// 环境判断工具类
export const deviceEnv = {
	// 判断是否是微信内置浏览器
	isWechatBrowser() {
		const ua = window.navigator.userAgent.toLowerCase();
		return ua.includes('micromessenger') && !ua.includes('miniProgram');
	},
	// 判断是否是微信小程序webview
	isWechatMiniProgram() {
		const ua = window.navigator.userAgent.toLowerCase();
		return ua.includes('micromessenger') && ua.includes('miniProgram');
		// return new Promise((resolve) => {
		// 	// 优先通过微信JS-SDK判断（最可靠）
		// 	if (window.wx && wx.miniProgram && typeof wx.miniProgram.getEnv === 'function') {
		// 	wx.miniProgram.getEnv((res) => {
		// 		resolve(res.miniprogram); // 官方API，精准判断
		// 	});
		// 	} else {
		// 	// 兜底：userAgent判断
		// 	const ua = window.navigator.userAgent.toLowerCase();
		// 	resolve(ua.includes('micromessenger') && ua.includes('miniprogram'));
		// 	}
		// });
	},
	// 判断是否是苹果Safari浏览器
	isIOSSafari() {
		// const ua = window.navigator.userAgent.toLowerCase();
		// return /iphone|ipad|ipod/.test(ua) && /safari/.test(ua) && !/chrome/.test(ua);
		if (!this.isRealIOS()) return false; // 先排除非真实iOS设备
		const ua = navigator.userAgent.toLowerCase();
		// 真实Safari的UA包含safari，但不含chrome/firefox等其他浏览器标识
		return /safari/.test(ua) && !/chrome|firefox|edge|brave/.test(ua);
	},
	// 判断是否是安卓设备
	isAndroid() {
		// const ua = window.navigator.userAgent.toLowerCase();
		// return ua.includes('android') || ua.includes('adr');
		return this.isRealAndroid();
	},
	isRealIOS() {
		const ua = navigator.userAgent.toLowerCase();
		const platform = navigator.platform.toLowerCase();
		// 核心：真实iOS设备的platform是iphone/ipad/ipod，且不是webdriver（排除模拟）
		const isIOSPlatform = /iphone|ipad|ipod/.test(platform);
		const isWebDriver = navigator.webdriver === true;
		const isIOSUA = /iphone|ipad|ipod/.test(ua);
		// 真实iOS：平台是iOS + 不是webdriver + UA包含iOS标识
		return isIOSPlatform && !isWebDriver && isIOSUA;
	},
	isRealAndroid() {
		const ua = navigator.userAgent.toLowerCase();
		const platform = navigator.platform.toLowerCase();
		const isWebDriver = navigator.webdriver === true;
		// 真实安卓：UA包含android + 不是webdriver + 平台不是mac/win/linux
		return /android/.test(ua) && !isWebDriver && !/mac|win|linux/.test(platform);
	},
};
